import { z } from 'zod'

const SENDER_PHONE_ERROR = 'Nomor handphone minimal 7-12 karakter.'

/** +62 counts as one character toward the 7-12 phone length rule. */
export function senderPhoneEffectiveLength(localDigits: string) {
  const local = localDigits.replace(/\D/g, '').replace(/^0+/, '')
  return 1 + local.length
}

export function isValidSenderPhone(localDigits: string) {
  const local = localDigits.replace(/\D/g, '').replace(/^0+/, '')
  if (!/^[0-9]*$/.test(local)) return false
  const length = senderPhoneEffectiveLength(local)
  return length >= 7 && length <= 12
}

const optionalUrl = z
  .string()
  .trim()
  .max(100)
  .refine((value) => value === '' || /^https?:\/\/.+/i.test(value), {
    message: 'Link toko harus diawali http:// atau https://',
  })

export const senderDetailSchema = z.object({
  name: z
    .string()
    .trim()
    .min(3, 'Panjang karakter antara 3-72')
    .max(72, 'Panjang karakter antara 3-72'),
  dialCode: z.literal('+62'),
  phone: z
    .string()
    .trim()
    .refine(isValidSenderPhone, { message: SENDER_PHONE_ERROR }),
  additionalAddress: z.string().max(50),
  socialMediaUrls: z.array(optionalUrl),
})

export type SenderDetailValues = z.infer<typeof senderDetailSchema>

export const saveGroupAddressResponseSchema = z
  .object({
    message: z.string().optional(),
  })
  .passthrough()
